export default __webpack_public_path__ + "5470294cd811781cfb94508a205b085c.svg";